module.exports = __webpack_public_path__ + "img/interaction-bar-with-search-v-luxury-ford.2139c40c.png";